import { CrudHandler } from './CrudHandler';
import { Identity } from '../domain/types';
import { RequestParams } from 'msw';

export class CustomerCrudHandler<T extends Identity> extends CrudHandler<T> {
  protected getKey(params: RequestParams): string {
    return params.customerId;
  }
}
